import { useQueryClient } from "@tanstack/react-query";

import { mmgKeys } from "./API/keys";
import { useFetchUserPledgeAndGivingData } from "./useFetchUserPledgeAndGivingData";

export default function useRefetchMMGData() {
  const fetchUserPledgeAndGivingData = useFetchUserPledgeAndGivingData();

  let queryClient = useQueryClient();

  function refetchMMGData() {
    fetchUserPledgeAndGivingData();
    queryClient.invalidateQueries(mmgKeys.alerts());
  }

  return refetchMMGData;
}
